
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount/status",
      function () {
        return require("private-next-pages/myaccount/status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount/status"])
      });
    }
  